module.exports = __webpack_public_path__ + "img/omanflag.1c2de3b6.png";